// src/components/TrustedBy.js

import React, { useState, useEffect } from 'react';

const TrustedBy = () => {
    // --- STATE MANAGEMENT ---
    const [partners, setPartners] = useState([]);

    // --- FETCH DATA FROM API ---
    useEffect(() => {
        // UPDATE: Changed '/api/partners' to '/api/school-partners'
        // Ab ye nayi table (school_partners) se data layega
        fetch('/api/school-partners')
            .then(res => res.json())
            .then(data => {
                if (Array.isArray(data)) {
                    setPartners(data);
                }
            })
            .catch(err => console.error('Failed to fetch partners:', err));
    }, []);

    return (
        <section className="py-12 overflow-hidden">
            {/* INLINE STYLES FOR ANIMATION (Taaki aapko CSS file na chedni pade) */}
            <style>{`
                @keyframes scroll {
                    0% { transform: translateX(0); }
                    100% { transform: translateX(-50%); }
                }
                .logo-slider {
                    display: flex;
                    width: max-content;
                    animation: scroll 20s linear infinite;
                }
                .logo-slider:hover {
                    animation-play-state: paused;
                }
            `}</style>

            <div className="max-w-full mx-auto px-4">
                <p className="text-center text-xs font-bold text-slate-400 uppercase tracking-[0.3em] mb-12">
                    AUTHORIZED RECRUITMENT PARTNER FOR VERIFIED SCHOOLS
                </p>

                {/* SLIDER CONTAINER */}
                {partners.length > 0 ? (
                    <div className="relative w-full overflow-hidden mask-gradient">
                        {/* 
                           Hum partners array ko 2 baar render kar rahe hain
                           taaki animation seamless (bina ruke) loop ho sake.
                        */}
                        <div className="logo-slider gap-x-12 md:gap-x-20 px-4">
                            {[...partners, ...partners].map((partner, index) => (
                                <div key={`${partner.id}-${index}`} className="flex-shrink-0 flex items-center justify-center">
                                    <img 
                                        src={partner.logo_path} // Backend se full path aa raha hai
                                        alt={partner.name || "School Logo"} 
                                        // Consistent styling maintained
                                        className="h-16 md:h-20 object-contain  transition-transform duration-300 filter" 
                                    />
                                </div>
                            ))}
                        </div>
                    </div>
                ) : (
                    // FALLBACK STATIC CONTENT (Jab tak aap admin se add nahi karte)
                    <div className="flex flex-wrap justify-center items-center gap-x-8 gap-y-4 opacity-90">
                        <div className="text-center text-slate-300 text-sm">
                            Loading Partners... or No Partners Added yet.
                        </div>
                    </div>
                )}
            </div>
        </section>
    );
};

export default TrustedBy;